import { render, staticRenderFns } from "./SettingScoutTemplates.vue?vue&type=template&id=24ed6047"
import script from "./SettingScoutTemplates.vue?vue&type=script&lang=js"
export * from "./SettingScoutTemplates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports